import { embedComponent } from '../../shared/iframeApp/index.js'

export const ComponentThumbnail = {
  isArtboard: true,
  class: 'grid-stack-item',
  round: 'Z2',
  position: 'relative',
  opacity: 1,
  fontWeight: '400',
  textDecoration: 'none',
  maxWidth: '100%',
  outline: '1px solid line',
  overflow: 'hidden',
  fontSize: '1rem',

  isPage: (el, s) => s.type === 'pages',
  '.isPage': {
    '::before': {
      content: '""',
      inset: 'D1',
      round: 'B',
      position: 'absolute',
      zIndex: 0,
      '@dark': { background: '#c9ccd0ff' },
      '@light': { background: '#e9eceeff' }
    }
  },

  isSelected: (el) => el.call('getSelected') === el,

  ':hover > span': {
    transform: 'translate3d(0, 0, 0)',
    opacity: 1
  },

  // Set `interactive: true` on a node to let the embedded project inside
  // the thumbnail receive pointer events (clicks, hover, scroll) just
  // like a live preview. Default is preview-only: all descendants except
  // the top-right `Label` span are click-blocked so the tile behaves as
  // a single selectable artboard on the canvas board.
  style: (el, s) => (s.interactive
    ? {}
    : { '& *:not(> span)': { pointerEvents: 'none !important' } }),

  attr: {
    'gs-w': (el, s) => s.settings?.gridOptions?.w ?? 3,
    'gs-h': (el, s) => s.settings?.gridOptions?.h ?? 2,
    'gs-x': (el, s) => s.settings?.gridOptions?.x,
    'gs-y': (el, s) => s.settings?.gridOptions?.y
  },

  Flex: {
    theme: 'document',
    class: 'grid-stack-item-content',
    round: 'Z2',
    border: '0',
    zIndex: 1,
    clip: 'rect(0, auto, auto, 0)',
    overflow: 'auto',
    maxHeight: '100%',
    width: '100%',

    style: {
      '&::-webkit-scrollbar': { width: '24px' },
      '&::-webkit-scrollbar-track': { background: 'transparent' },
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(0,0,0,0.3)',
        borderRadius: '12px',
        border: '8px solid transparent',
        backgroundClip: 'padding-box'
      },
      scrollbarWidth: 'auto'
    },

    // Frame every tile so the project's Scratch config is scoped to its
    // iframe realm and can't override canvas chrome themes on hard-refresh.
    onRender: (el, s) => {
      if (el.__contentSet) return
      const data = s?.root?.data
      if (!data || !s?.key) return

      el.set({
        width: '100%',
        height: '100%',
        FrameHost: {
          tag: 'iframe',
          width: '100%',
          height: '100%',
          border: '0',
          display: 'block',
          attr: { 'data-canvas-frame': s.key },
          onRender: (fel) => {
            if (fel.__mounted) return
            fel.__mounted = true
            embedComponent(fel.node, data, { key: s.key, fullsize: true })
              .catch((err) => console.warn('[thumbnail frame] failed for', s.key, err))
          }
        }
      })
      el.__contentSet = true
    },

    onWheel: (ev, el) => {
      if (!el.node) return
      const { scrollTop, clientHeight, scrollHeight } = el.node
      const isScrollable = scrollHeight > clientHeight
      if (!isScrollable) return

      const atTop = scrollTop === 0
      const atBottom = scrollTop + clientHeight >= scrollHeight - 1
      const shouldStop =
        (ev.deltaY < 0 && !atTop) || (ev.deltaY > 0 && !atBottom)

      if (shouldStop) {
        ev.preventDefault()
        ev.stopPropagation()
        el.node.scrollTop += ev.deltaY
      }
    }
  },

  Label: {
    extends: 'Span',
    position: 'absolute',
    bottom: 'Z',
    left: 'Z',
    padding: 'W X',
    background: 'rgba(0,0,0,0.65)',
    color: 'white',
    round: 'Y',
    fontSize: 'Z',
    opacity: 0,
    transition: 'opacity 150ms',
    text: (el, s) => s.title || s.key
  },

  ':hover > span': { opacity: 1 },

  onMouseenter: (ev, el, s) => {
    const scope = el.call('getCanvasScope')
    if (!scope) return
    scope.layerHostComponent = s.key
    el.call('activateHovered')
  },

  onMouseleave: (ev, el) => {
    const scope = el.call('getCanvasScope')
    if (!scope) return
    scope.hoverLayer = null
    el.call('activateHovered', null)
  },

  onMousemove: (ev, el) => {
    if (el.call('isCanvasMode', 'inspectMode')) {
      if (!ev.target?.ref) return
      const path = [...ev.target.ref.__ref.path]
      path.splice(0, 8)
      const scope = el.call('getCanvasScope')
      scope.hoverLayer = path.filter((key) => key[0] !== key[0].toLowerCase())
    }
  },

  onClick: (ev, el, s) => {
    ev.stopPropagation()
    el.call('activateSelected')
  },

  onDblclick: (ev, el) => {
    ev.stopPropagation()
    // TODO: activate chosen mode for component editing
  },

  onContextmenu: (ev, el, s) => {
    ev.preventDefault()
    ev.stopPropagation()
  }
}
